<div id="map-elevation-computation"
     class="hidden">
</div>
